import React,{useEffect, useState,useLayoutEffect} from "react";
import Breadsrumb1 from "../Breadcrumbs/Breadcrumb1";
import { useLocation } from '@reach/router';
import { Brands } from "../Brand";
import { Variant } from "../Products";
import {getMetaCategories, getProductByCategories_v1, getBreadcrumb, getMenuRoot} from "../../service/myProductService";
import { getListBanner } from '../../service/campaignService';
// import Pagination from "react-js-pagination";
import ReactPaginate from 'react-paginate';
import { ItemDefaultV2 } from "../Products/Item";
import ReactHtmlParser from 'react-html-parser';
import Slider from "@mui/material/Slider";
import { FromatNumberVIE } from "../../utils/format";
import Img from '../Images';

const Category =()=>{
    const location = useLocation();
    let uri = location.pathname?.replace('.html','').replace('/','');
    const [meta, setMeta] = useState([]);
    const [showDes, setShowDes] = useState(false);
    const [range, setRange] = React.useState([0, 100]);
    var [productList, setProductList] = useState([]);
    const [metadata, setMetadata] = useState([]);
    const [showAlert, setShowAlert] = useState(false);
    const [brand, setBrand] = useState([]);
    const [scrollPosition, setPosition] = useState(0);
    const loadProductOnCategory=(uri, page, pagesize, get_brand_info, brand_url_key, min, max)=>{
        try{
            getProductByCategories_v1(page, pagesize, uri,  get_brand_info, brand_url_key, min, max).then((response)=>{
            if(+response.status===200){
            setMetadata(response['metadata']);
            if(get_brand_info !== ''){
                setBrand(response['brandInfo']);
            }
            setProductList(response.message);     
            }
        });
        }catch(e){console.log(e)}
    
    }
    useLayoutEffect(() => {
        function updatePosition() {
          setPosition(window.pageYOffset);
          window.localStorage.setItem("scrollPosition", window.pageYOffset);
        }
        window.addEventListener('scroll', updatePosition);
        updatePosition();

        return () => window.removeEventListener('scroll', updatePosition);

    }, []);
    const [breandcrumb, setBreandcrumb] = useState([]);
    const loadBreandcrumb=(uri)=>{
        try{
            getBreadcrumb(uri).then((response)=>{
            if(+response.status===200){
                setBreandcrumb(response.message);            
            }
        });
        }catch(e){console.log(e)}
    
    }
    const [menuRoot, setMenuRoot] = useState([]);
    const [showMenu, setShowMenu] = useState(true);
    const loadMenu = async(uri)=>{
        await getMenuRoot(uri).then((response)=>{
            if(+response.status === 200){
                setMenuRoot(response.message);

            }
        });
    }
    const [bannerPopup, setBannerPopup] = useState([]);
    const loadBannerPopup=()=>{
        try {
            getListBanner('W016C01').then((response)=>{
                if(response.status === 200 && response['message'] !== 'Không tìm thấy dữ liệu.'){
                    setBannerPopup(response['message']);
                }
            })
        } catch(err) {
          console.error(err);
        }  
    }
    const [showPopupDownloadApp, setShowPopupDownloadApp] = useState(false);
    const [wd, setWd] = useState(0);
    useEffect(()=>{
        window.localStorage.setItem('brand_search',JSON.stringify([]));
        window.localStorage.setItem('brands',JSON.stringify([]));
        setProductList([]);
        loadBreandcrumb(uri);
        loadProductOnCategory(uri, 0, 20, true, '', range[0]*100000, range[1]*100000);
        loadMenu(uri);
        try{
            getMetaCategories(uri).then((response)=>{
                if(+response.status === 200){
                    if(response['message'].description?.length < 2000){
                        setShowDes(true);
                    }
                    setMeta(response['message']);
                    window.localStorage.setItem('nameCategory', response['message']?.name);
                }else{
                    setMeta([]);
                    window.localStorage.setItem('nameCategory', '');
                }
            });
        }catch(e){console.log(e);}
        // setShowAlert(true);
        setShowMenu(true)
        setWd(document.getElementById("filter").clientWidth);
        loadBannerPopup();
         var _pageViewShowPopup = sessionStorage.getItem("pageViewShowPopup");
            if (_pageViewShowPopup === undefined) {
                sessionStorage.setItem("pageViewShowPopup", 0);
            }
             if (_pageViewShowPopup !== undefined && +_pageViewShowPopup !== 1) {
            setTimeout(function() {
                    setShowPopupDownloadApp(true);
                    // document.querySelector('.modal-open').style.overflow = 'hidden';
                    sessionStorage.setItem("pageViewShowPopup", 1);
                }, 9000);
            }
      },[]);

      const toggleShowMore = () => {
        setShowDes(!showDes);
        if(showDes){
          window.scrollTo(0,700)
        }
      }
    const handlePageChange=(event)=>{
        var _perpage = +event.selected+1;
        if(_perpage > 0){
            loadProductOnCategory(uri, event.selected, 20, true, '', range[0]*100000, range[1]*100000);
            window.scrollTo(0,400);
        }
      }

      function handleChanges(event, newValue) {
        setRange(newValue);
        loadProductOnCategory(uri, 0, 20, true, '', newValue[0]*100000, newValue[1]*100000);
     }
     const [brands, setBrands] = useState([]);
     const [brandsearch, setBrandsearch] = useState([]);
     const callBackFunction = (item)=>{
        var _array = JSON.parse(window.localStorage.getItem('brand_search'));
        var _array_brands = JSON.parse(window.localStorage.getItem('brands'));
        var _fg = false;
         if (_array.length > 0) {
            _array?.forEach((data, key) => {
                if (data === item.url_key) {
                    _array.splice(key, 1);
                    document.getElementById(item.url_key).checked = false;
                    _fg = true;
                    _array_brands.splice(key, 1);
                }
            });
        } else {
            _array.push(item.url_key);
            _fg = true;
            _array_brands.push(item);
        }
        if(_fg === false){
            _array.push(item.url_key);
            _array_brands.push(item);
        }
        window.localStorage.setItem('brand_search',JSON.stringify(_array));
        window.localStorage.setItem('brands',JSON.stringify(_array_brands));
        setBrandsearch(_array);
        setBrands(_array_brands);
        loadProductOnCategory(uri, 0, 20, '', JSON.parse(window.localStorage.getItem('brand_search')), range[0]*100000, range[1]*100000);
     }
     const handleClearAll =()=>{
        var _array = JSON.parse(window.localStorage.getItem('brand_search'));
         if (_array.length > 0) {
            _array?.forEach((data) => {
                    document.getElementById(data).checked = false;
            });
        }
        window.localStorage.setItem('brand_search',JSON.stringify([]));
        window.localStorage.setItem('brands',JSON.stringify([]));
        setBrandsearch([]);
        setBrands([]);
        loadProductOnCategory(uri, 0, 20, '', JSON.parse(window.localStorage.getItem('brand_search')), range[0]*100000, range[1]*100000);
     }
     const call = setInterval(() => {
         setShowAlert(true);
         clearInterval(call);
    }, 2000);

     const handleOpentRedirect=(uri)=>{
            //  document.querySelector('.modal-open').style.overflow = 'unset'
            sessionStorage.setItem("pageViewShowPopup", 1);
            setShowPopupDownloadApp(false);
            window.location.href = uri;
        }
        const handleClosepopup=()=>{
            setShowPopupDownloadApp(false);
            // document.querySelector('.modal-open').style.overflow = 'unset';
            sessionStorage.setItem("pageViewShowPopup", 1);
        }
    return(
        <>
        <div className="container m-auto p-0">
            <div className="row row--maint m-0 ">
                <Breadsrumb1 data={breandcrumb}/>
                {
                    meta?.url_image && meta?.url_image !== '' ?(
                        <div className="col-12 p-0 pb-4">
                    {/* <img className="w-100" src={meta?.url_image??DefaultImg} alt=""/> */}
                    <Img imgTitle={meta?.name} url={meta?.url_image??''} className="banner-cate" style=""/>
                </div>
                    ):(null)
                }
            </div>
            <div className="row row--maint m-0 ">

                <div className="col-2 p-0 col--left align-items-stretch">
                    <div className="row m-0">
                        {
                            brands.length > 0 ? (
                            <>
                            <div className="text-end border-1 border-bottom p-0 py-2">
                                <span className="text-gray-400 delete--all" onClick={handleClearAll}>Xóa tất cả 
                                <img className="trash" src="/static/image/trash.svg" alt="icon"/>
                                {/* <i className="bi bi-trash"></i> */}
                                </span>
                            </div>
                            <div className="text-start border-1 border-bottom p-0 py-3 mb-3">
                                {
                                    brands.map((brand, i)=>{
                                        return <div key={i} className="mb-2" onClick={()=>callBackFunction(brand)}><span className="bg-gray-300 p-2">{brand.name}<i className="bi bi-x fs-5 ms-2"></i></span></div>
                                    })
                                }
                            </div>
                            </>
                            ):(null)
                            
                        }
                        <div className="p-0 mb-2">
                        <div className="row box-title p-0 m-0" onClick={()=>setShowMenu(!showMenu)}>
                            <div className="col-9" ><span >Nhóm sản phẩm</span></div>
                            <div className="col-3 text-right"><i className={showMenu? "bi bi-chevron-up fs-6":"bi bi-chevron-down fs-6"}></i></div>
                        </div>
                        {
                            showMenu ? (
                                <ul className="p-0 mt-2 menu-1">
                                <li className="fw-medium my-1">
                                    <span className="root-cate"><a href={"/"+menuRoot.url_key+".html"}>{menuRoot.name}</a></span>
                                    {
                                        menuRoot.child?.length >0 ?(
                                            <ul className="p-0 menu-2 h-auto border-0">
                                                {
                                                    menuRoot.child?.map((itemChild,index)=>{
                                                        return <li key={index} className={itemChild.selected ? "py-2 li-active":"py-2"}>
                                                                
                                                                {
                                                                        itemChild.child && itemChild.child.length > 0 ? (
                                                                        <span > 
                                                                            <a aria-label className="collapsed position-relative" data-bs-toggle="collapse" href={"#"+itemChild._id} aria-expanded={itemChild.selected ? "true":"false"}>
                                                                                {/* <i className={itemChild.selected ? ("bi bi-chevron-down me-1"):("bi bi-chevron-right me-1")}></i> */}
                                                                                <div className="d-none">chevron</div>
                                                                                <i className="bi bi-chevron-right me-1"></i>
                                                                            </a>
                                                                            
                                                                            <a href={"/"+itemChild.url_key+".html"}>{itemChild.name}</a></span>
                                                                        ):(
                                                                            // <span className="pading-2">{itemChild.name}</span>
                                                                            <span> <a href={"/"+itemChild.url_key+".html"}>{itemChild.name}</a></span>
                                                                        )
                                                                    }
                                                                {
                                                                    itemChild.child?.length >0 ?(
                                                                        <ul id={itemChild._id} class={itemChild.selected ? "menu-3 ps-3 collapse show":"menu-3 ps-3 collapse"}>
                                                                        {
                                                                            itemChild.child?.map((child, index1)=>{
                                                                                return  <li key={index1} className={child.selected ? "py-2 li-active":"py-2 "}>
                                                                                        <a href={"/"+child.url_key+".html"}>
                                                                                            <span >
                                                                                                {child.name}
                                                                                            </span>
                                                                                        </a>
                                                                                    </li>
                                                                            }
                                                                            )
                                                                        }
                                                                    </ul>
                                                                    ):(null)
                                                                }
                                                            </li>
                                                    })
                                                }
                                            </ul>
                                        ):(null)
                                    }
                                </li>
                            </ul>
                            ):(null)
                        }    
                        </div>
                        <div className="col-12 p-0 mb-3 price-rate">
                            
                            <div className="row box-title p-0 m-0">
                                <div className="col-9"><span >Khoảng giá</span></div>
                            </div>
                            <div className="d-flex justify-content-between my-3">
                            <span>{FromatNumberVIE(range[0]*100000)}đ</span> <span>{FromatNumberVIE(range[1]*100000)}đ</span>
                            </div>
                            <div className="ps-1 pe-1" >
                                <Slider value = {range} onChange = {handleChanges}/>
                            </div>
                        </div>
                        <Brands Data={brand} parentCallback={callBackFunction}/>
                        {/* <Variant Data={null}/> */}
                    </div>
                </div>

                <div className="col-10 p-0 align-items-stretch filter" id="filter">
                    <div className="row m-0 pading-box-rigth">
                        <div style={{"width": wd }}  className={scrollPosition > 350 && scrollPosition < +document.documentElement.offsetHeight - 1000 ? ("d-flex bg-gray-500 py-2 justify-content-between fs-12 filter-tool-bar fix-filter"):("d-flex bg-gray-500 py-2 justify-content-between fs-12 filter-tool-bar")}>
                            <div className="d-flex align-items-center ms-3 count-item">
                                <span>{metadata.total_item} sản phẩm</span>
                            </div>
                            <div className="d-flex text-color">
                                <button className="bg-white border border-black py-2 px-4 mx-1 active">Phù hợp</button>
                                <button className="bg-white border-btn-gray py-2 px-4 mx-1">Bán chạy</button>
                                <button className="bg-white border-btn-gray py-2 px-4 mx-1">Hàng mới</button>
                                <button className="bg-white border-btn-gray py-2 px-4 mx-1">Giá thấp - cao</button>
                                <button className="bg-white border-btn-gray py-2 px-4 mx-1">Giá cao - thấp</button>
                            </div>
                        </div>
                        { 
                            productList.length > 0 ?(
                                productList?.map((item, index)=>(
                                    <div className="col-sm-6 col-md-4 col-lg-3 p-0 mb-3 product-list">
                                        <ItemDefaultV2 key={index} item={item} index={index} showPriceRow='true' showpercen='false'/>
                                    </div>
                                ))
                            ):(
                                showAlert === true && productList.length === 0 ?(
                                    <div className='message pdr-10'>
                                        <div className='info'>
                                        <i className="fa fa-exclamation-triangle fa-lg" aria-hidden="true"></i> <span>Không có sản phẩm phù hợp.</span>
                                        </div>
                                        
                                    </div>
                                ):(<div id="landing-web">
                                <div className="loading-page"  style={{textAlign:"center"}}>
                                    <img src="/../images/loading.gif" alt="icon"/>
                                </div>
                            </div>)
                                
                                // <div>Chưa có dữ liệu</div>
                            )
                            
                        }
                        
                        {
                            metadata?.total_page > 1 ?(
                                <div className="col-12 p-0 my-4">
                                    <div className="d-flex justify-content-center pagination">
                                        <ReactPaginate
                                            breakLabel="..."
                                            nextLabel='›'
                                            onPageChange={handlePageChange}
                                            pageRangeDisplayed={1}
                                            pageCount={metadata?.total_page}
                                            previousLabel="‹"
                                            renderOnZeroPageCount={null}
                                        />
                                    </div> 
                                </div>
                            ):(null)
                        }
                        
                        {
                            meta?.description && meta?.description !== '' ?(
                                <div className={showDes ? "col-12 px-0 position-relative cate-des" : "col-12 px-0 position-relative cate-description"}>
                                    <div className={showDes ? "description-content position-relative" : "description position-relative"}>
                                        {/* {ReactHtmlParser(meta?.description)} */}
                                        {showDes ? ReactHtmlParser(meta?.description) : ReactHtmlParser(meta?.description?.substring(0, 2000))}
                                    </div>
                                    <div className={showDes ? "text-center" : "text-center position-absolute w-100 bottom-0"}>
                                        {meta?.description?.length > 2000 && (
                                            <button className="rounded-3 text-gray-400 border bg-white w-bt" onClick={toggleShowMore}> {showDes ? "Thu gọn" : "Xem thêm"}</button>
                                       )} 
                                    </div>
                                </div>
                            ):(null)
                        }
                        
                    </div>
                </div>
            </div>
        </div>

        {bannerPopup.length > 0 && showPopupDownloadApp === true ? (
        <div id="modal-msg">
          <div className="modal">
              <div className="modal-content-popup">
                  <div className="modal-body p-0 ">
                      <div className="position-relative">
                      <img onClick={()=>handleOpentRedirect(bannerPopup[0]?.link)} src={bannerPopup[0]?.images} alt="icon-popup" className="pointer"/> 
                      <div className="position-absolute close-button">
                        <span onClick={handleClosepopup}><i className="bi bi-x-circle"></i></span>
                      </div>
                      </div>
                  </div>
              </div>
          </div>
        </div>
           ):(null)}
        </>
    )
}
export default Category;